import {memo} from "react";

function Mobile({ className, children=null ,style}) {
  return (
    <div className={`md:hidden ${className}`} style={style}>{children}</div>
  );
}

export default memo(Mobile);
